import ApiService from "@/api/baseApi/api-service";
import { Config } from "../../config";
import {
  IGetTimeSlots,
  IGetTimeSlotsDetails,
  IGetTimeSlotsDetailsParams,
  IGetTimeSlotsParams,
} from "./interfaces/api-time-slots-interfces";

const URLs = {
  timeSlots: "/time-slots",
  timeSlotsSpecific: "/time-slots/specific",
};
class ApiTimeSlots extends ApiService {
  constructor(config: Config) {
    super({ ...config });
  }
  getTimeSlots = (params: IGetTimeSlotsParams): Promise<IGetTimeSlots> =>
    this.get(URLs.timeSlots, { params });
  getTimeSlotsSpecific = (
    params: IGetTimeSlotsDetailsParams
  ): Promise<IGetTimeSlotsDetails> =>
    this.get(URLs.timeSlotsSpecific, { params });
}
export default ApiTimeSlots;
